/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Setting_Data_Type_UrlInputs */

const en_enum_setting_data_type_url = /** @type {(inputs: Enum_Setting_Data_Type_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Type URL`)
};

const de_enum_setting_data_type_url = /** @type {(inputs: Enum_Setting_Data_Type_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Typ URL`)
};

/**
* | output |
* | --- |
* | "Data Type URL" |
*
* @param {Enum_Setting_Data_Type_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_setting_data_type_url = /** @type {((inputs?: Enum_Setting_Data_Type_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Setting_Data_Type_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_setting_data_type_url(inputs)
	return de_enum_setting_data_type_url(inputs)
});